export default "__VITE_ASSET__CDyOFD4Q__"